module.exports = __webpack_public_path__ + "static/media/AddUsers.5143f2c9.svg";